import { create } from 'zustand';
import type { VariationStatus } from '@billda/api';

interface VariationsUIState {
  siteIdFilter: number | undefined;
  setSiteIdFilter: (siteId: number | undefined) => void;
  statusFilter: VariationStatus | undefined;
  setStatusFilter: (status: VariationStatus | undefined) => void;
}

export const useVariationsUIStore = create<VariationsUIState>()(set => ({
  siteIdFilter: undefined,
  setSiteIdFilter: siteId => set({ siteIdFilter: siteId }),
  statusFilter: undefined,
  setStatusFilter: status => set({ statusFilter: status }),
}));
